export interface IModelPromptLibraryResponse {
  id: number;
  name: string;
  promptStarter: string;
  description: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelPromptLibrary {
  id: number;
  name: string;
  promptStarter: string;
  description: string;
  createdAt: string | Date;
  updatedAt: string | Date;

  constructor(props = {} as IModelPromptLibraryResponse) {
    props = props ?? {};
    this.id = props.id;
    this.name = props.name;
    this.promptStarter = props.promptStarter;
    this.description = props.description;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }
}

export interface IModelCreatePromptLibraryRequest {
  name: string;
  promptStarter: string;
  description: string;
}